
































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import gql from 'graphql-tag'

import AppCheckbox from '@/components/AppCheckbox.vue'
import { ApolloResponse } from '@/interfaces/apollo'
import { Snack, SnackType } from '@/interfaces/snack'
import { User } from '@/modules/User/interfaces/user'
import { dispatchSignIn } from '@/store/dispatches'
import { showErrors, showNotification } from '@/utils/snack'
import { signIn, getGoogleAuthUrl, signInWithGoogle } from '@/modules/User/gql/user.gql'

import { State } from 'vuex-class'

@Component({
  components: {
    AppCheckbox
  }
})

export default class SignIn extends Vue {
  password = ''
  username = ''

  showPWD = false

  rememberMe = true

  normalBtnLoading = false
  normalBtnDisabled = false
  googleBtnLoading = false
  googleBtnDisabled = false

  version = process.env.VUE_APP_VERSION

  rules = {
    required: (value:string) => !!value || 'Required.'
  }

  valid = true

  get form (): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  @State(state => state.user.me) me!: User

  validate (event: Event) {
    if (this.form.validate()) {
      this.signIn()
    }
  }

  mounted () {
    const queries = window.location.search.substring(1)
    if (queries) {
      this.signInWithGoogle((queries.split('&')[0]).split('=')[1])
    }
  }

  async getGoogleAuthUrl () {
    this.normalBtnDisabled = true
    this.googleBtnDisabled = true
    this.googleBtnLoading = true
    try {
      const result = await this.$apollo.query({
        query: getGoogleAuthUrl
      })

      if (result.data !== null) {
        window.location.href = result.data.getGoogleAuthUrl
      }
    } catch (error) {
      this.normalBtnDisabled = false
      this.googleBtnDisabled = false
      this.googleBtnLoading = false
      showErrors(error.graphQLErrors)
    }
  }

  async signInWithGoogle (authCode: string) {
    this.normalBtnDisabled = true
    this.googleBtnDisabled = true
    this.googleBtnLoading = true
    try {
      const result = await this.$apollo.mutate({
        mutation: signInWithGoogle,
        variables: {
          authCode
        }
      })
      const me: User = result.data.signInWithGoogle
      if (me) {
        this.signInSuccessed(me)
      }
    } catch (error) {
      this.normalBtnDisabled = false
      this.googleBtnDisabled = false
      this.googleBtnLoading = false
      showErrors(error.graphQLErrors)
    }
  }

  async signIn () {
    this.normalBtnLoading = true
    this.normalBtnDisabled = true
    this.googleBtnDisabled = true
    try {
      const result = await this.$apollo.mutate({
        mutation: signIn,
        variables: {
          username: this.username,
          password: this.password
        }
      })

      const me: User = result.data.signIn
      if (me) {
        this.signInSuccessed(me)
      }
    } catch (error) {
      this.normalBtnLoading = false
      this.normalBtnDisabled = false
      this.googleBtnDisabled = false
      showErrors(error.graphQLErrors)
    }
  }

  signInSuccessed (me: User) {
    if (me.jwt) {
      localStorage.setItem(process.env.VUE_APP_JWT_NAME || 'VERGE_JWT_TOKEN', me.jwt)
    }
    dispatchSignIn(me)
    showNotification({
      msg: 'login successfully',
      type: SnackType.Success
    })
    this.normalBtnLoading = false
    this.normalBtnDisabled = false
    this.googleBtnDisabled = false
    this.googleBtnLoading = false
    setTimeout(() => {
      const queries = window.location.search.substring(1)
      if (queries) {
        window.location.href = window.location.href.split('?')[0]
      } else {
        this.$router.push({ name: 'CaseDashboard' })
      }
    }, 1000)
  }
}
